<template>
  <el-dialog
    center
    width="600px"
    :title="(isEdit ? '编辑' : '新增') + '系统权限'"
    :visible.sync="dialogFormVisible"
    @close="resetForm"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
      <el-form-item
        label="权限名称"
        :label-width="formLabelWidth"
        prop="name"
        v-if="!isEdit"
      >
        <el-input
          v-model="editForm.name"
          auto-complete="off"
          placeholder="请输入权限名称"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="权限编码"
        :label-width="formLabelWidth"
        prop="code"
        v-if="!isEdit"
      >
        <el-input
          v-model="editForm.code"
          auto-complete="off"
          placeholder="请输入权限编码"
        ></el-input>
      </el-form-item>
      <el-form-item label="权限描述" :label-width="formLabelWidth">
        <el-input
          v-model="editForm.remark"
          auto-complete="off"
          placeholder="请输入权限描述"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button
        @click="
          dialogFormVisible = false;
          resetForm();
        "
        >取 消</el-button
      >
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
//import { houseList } from '@/api/houseApi.js';
import { addMenuSmApi, updateSmPermitApi } from '@/api/user.js';
export default {
  name: 'AlarmRuleForm',
  props: ['list'],
  data() {
    return {
      dialogFormVisible: false,
      editForm: {
        code: '',
        name: '',
        remark: '',
      },
      isEdit: false,
      editRules: {
        name: [
          { required: true, message: '权限名称不能为空', trigger: 'blur' },
        ],
        code: [
          { required: true, message: '权限编码不能为空', trigger: 'blur' },
        ],
      },
      formLabelWidth: '120px',
    };
  },

  methods: {
    resetForm() {
      this.editForm = {};
      this.$refs.editForm.resetFields();
    },
    async submitEdit() {
      this.$refs.editForm.validate(async (valid) => {
        if (!valid) return this.$message.error('格式不对哦  ，检查一下呗!');
        if (this.isEdit) {
          this.editSubmit();
        } else {
          this.addSubmit();
        }
      });
    },
    async editSubmit() {
      const data = `permitId=${this.editForm.permitId}&remark=${this.editForm.remark}`;
      try {
        let res = await updateSmPermitApi(data);
        if (res.code !== 200) return;
        this.$message.success('编辑成功');
        this.dialogFormVisible = false;
        this.$refs.editForm.resetFields();
        this.$parent.fetchData();
      } catch (error) {
        window.console.log(error);
      }
    },
    async addSubmit() {
      const data = `code=${this.editForm.code}&name=${this.editForm.name}&remark=${this.editForm.remark}`;
      try {
        let res = await addMenuSmApi(data);
        if (res.code !== 200) return;
        this.$message.success('新增成功');
        this.dialogFormVisible = false;
        this.$refs.editForm.resetFields();
        this.$parent.fetchData();
      } catch (error) {
        window.console.log(error);
      }
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  min-height: 70px;
  line-height: 70px;
  text-align: center;
}
.avatar {
  width: 100px;
  display: block;
}
</style>
